<script lang="ts">
    import cn from 'classnames';
    import { configService } from '$lib/services';

    import { IconList, type IconListItem } from '@components/common/icon-list';
    import { CustomIcon, getIcon } from '@components/icons';
    // eslint-disable-next-line no-restricted-imports
    import { globalStore } from '@components/stores';
    import { LL } from '@i18n/i18n-svelte';
    import { MINUTE_IN_SECONDS } from '@shared/constants';
    import { UserGender } from '@shared/types';
    import { Font, FontTypes } from '@uikit/font';
    import { IconName } from '@uikit/svg-icon';

    import s from './description.module.css';

    export let gender: UserGender | undefined = undefined;
    export let classes = '';
    export let title: string | undefined = undefined;

    const items: IconListItem[] = [
        {
            icon: IconName.Comments,
            text: $LL.auth.features.chat(),
        },
        {
            icon: getIcon(CustomIcon.shield),
            text: $LL.auth.features.privacy(),
        },
        {
            icon: IconName.Earth,
            text: $LL.auth.features.meetPeople(),
        },
    ];

    function getTitleText(seconds: number) {
        if (gender === UserGender.Female) {
            return $LL.auth.title();
        }

        if (seconds > MINUTE_IN_SECONDS) {
            return $LL.auth.titleFreeMinutes({ minutes: seconds / 60 });
        } else if (seconds > 0 && seconds < MINUTE_IN_SECONDS) {
            return $LL.auth.titleFreeSeconds({ seconds });
        }

        return $LL.auth.title();
    }
</script>

<div
    class={cn(s.root, classes)}
>
    <Font
        className={s.title}
        tagName={FontTypes.TagName.h2}
        type={$globalStore.isDesktopSite ? FontTypes.Type.h2 : FontTypes.Type.h3}
        isBold
    >
        {#if title}
            {@html title}
        {:else}
            {@html getTitleText(configService.get('welcomeTimePackage').afterSignupSeconds)}
        {/if}
    </Font>

    <IconList {items}/>
</div>
